<!-- ======= Footer ======= -->
<footer id="footer" class="footer">
  <div class="copyright">
    &copy; Copyright <strong><span>Patient Tracker (V1.0)</span></strong
    >.
  </div>
</footer>
<!-- End Footer -->
